import { Error, Loader, StreetAddress } from '../../../common'
import { selectSelectedApprovalRequest } from '../../../../selectors/approvalRequests'
import { getContactInfoForOrg } from '../../../../selectors/orgContactInformation'
import { fetchContactInformation } from '../../../../actions/settings'
import { isEmpty } from '../../../../utils/common'
import { formatPhoneNumber } from '../../../../utils/numbers'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const {
    orgContactInformation: { fetching, error },
  } = state
  const { orgId, aiCode } = selectedApprovalRequest
  return {
    contactInfo: getContactInfoForOrg(state, orgId),
    orgId,
    aiCode,
    fetching,
    error,
    panelIsOpen,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ fetchContactInformation }, dispatch)

const CoordinatorContactInformation = ({ contactInfo }) => {
  if (!isEmpty(contactInfo?.coordinator)) {
    const { firstName, lastName, email, telephone } = contactInfo.coordinator
    return (
      <div className="col-lg-6 col-md-12 col-sm-6 col-xs-12" style={{ paddingBottom: '1.5em' }}>
        <h5 style={{ marginBottom: '8px' }}>Coordinator</h5>
        <div>
          {firstName} {lastName}
        </div>
        <div>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
        <div>{formatPhoneNumber(telephone)}</div>
      </div>
    )
  } else return null
}

const SchoolInformation = ({ contactInfo, error }) => (
  <div className="col-lg-6 col-md-12 col-sm-6 col-xs-12" style={{ paddingBottom: '1.5em' }}>
    <h5 style={{ marginBottom: '8px' }}>School</h5>
    {!isEmpty(contactInfo?.shippingAddress) && !error ? (
      <StreetAddress {...contactInfo.shippingAddress} />
    ) : (
      <div>
        <em>Not available</em>
      </div>
    )}
  </div>
)

class ContactInformation extends Component {
  componentDidMount() {
    const { orgId, aiCode, contactInfo, fetchContactInformation } = this.props

    if (isEmpty(contactInfo)) {
      fetchContactInformation(orgId, aiCode)
    }
  }

  componentDidUpdate(prevProps) {
    const { orgId, aiCode, panelIsOpen, contactInfo, fetchContactInformation } = this.props

    if (panelIsOpen && prevProps.orgId !== orgId && isEmpty(contactInfo)) {
      fetchContactInformation(orgId, aiCode)
    }
  }

  render() {
    const { contactInfo, fetching, error } = this.props

    if (fetching) {
      return <Loader />
    }

    return (
      <div className="row">
        <CoordinatorContactInformation contactInfo={contactInfo} />
        <SchoolInformation contactInfo={contactInfo} error={error} />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactInformation)
